<template>
  <div class='ExportCard'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table" ref="refTable">
      <template v-slot:BtnSlot>
          <el-button size="small" @click="exportCardAll">导出全部</el-button>
          <el-button type="primary" size="small" @click="exportCard">导出选中</el-button>
      </template>
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'

const typeProps = { label: 'name', value: 'id' }
const stateProps = { label: 'text', value: 'value' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', options: [], props: typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Date', label: '有效期：', prop: 'validPeriod', placeholder: '请选择有效期' },
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Select', label: '状态：', prop: 'state', options: [], props: stateProps, change: row => '', placeholder: '请选择状态' },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes },
          { type: 'Input', label: '导出次数：', prop: 'exportCount', placeholder: '请输入导出次数' }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },

      multipleSelection: [], // 选中的
      selectedExportCount: false,
      Table: { // 表格
        paddingRight: true,
        btnSlot: true,
        handle: false,
        selectionHandle: (val) => this.handleSelectionChange(val),
        data: [],
        column: [
          { prop: '_a', type: 'selection' },
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'cardPrivateNo', label: '内部卡号' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'stateText', label: '状态' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'updateTime', label: '更新时间' },
          { prop: 'exportCount', label: '导出次数' }
        ]

      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

    searchHandleForm () {
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () {
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getCardPagination(params)
        .then((res) => {
          pager.count = res.data.total
          Table.data = res.data.list.map((item) => ({
            ...item,
            stateText: item.state.text,
            denomination: item.denomination
          }))
        })
    },

    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    // 获取状态
    getCardStates () {
      this.$http.getCardStates()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('状态')) {
                item.options = res.data
              }
            })
          }
        })
    },

    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('卡类型')) {
                item.options = res.data
              }
            })
          }
        })
    },

    // 导出卡
    exportCard () {
      const el = this.$refs.refTable && this.$refs.refTable.$refs.multipleTable
      if(!el) return
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择一张你要导出的卡')
        return
      }
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (this.multipleSelection[i].exportCount > 0) {
          this.selectedExportCount = true
          this.$confirm('所选记录中有部分已导出，需要重复导出吗？', '提示', {
            confirmButtonText: '继续导出',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.exportCardApi(el)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消导出'
            })
          })
        }
        break
      }
      if (!this.selectedExportCount) {
        this.exportCardApi(el)
      }
    },
    // 导出全部
    exportCardAll () {
      this.$http.exportCard(Object.assign(this.search.searchData, { ids: 0 })).then(res => {
        if(res.status === 200) {
          this.$message.success(res.msg)
          setTimeout(()=>{
            this.getItemList()
          },1000)
        }
      })
    },
    // 调用导出接口
    exportCardApi (el) {
      const params = {
        ids: this.multipleSelection.map((item) => item.id).join(',')
      }
      this.$http.exportCard(params)
        .then((res) => {
          if (res.status === 200) {
            setTimeout(()=>{
              this.getItemList()
            },1000)
            el.clearSelection()
            this.selectedExportCount = false
            this.$message.success(res.msg)
          }
        })
    },

    init () {
      this.getItemList()
      this.getCardStates()
      this.getCardTypeList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
